/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable no-plusplus */
import React from 'react';

import SubPageLayout from '../components/templates/SubPageLayout';
import Layout from '../components/templates/Layout';
import GalleryPage from '../components/pages/GalleryPage';

const Gallery = () => (
  <Layout>
    <SubPageLayout title="시공갤러리">
      <GalleryPage />
    </SubPageLayout>
  </Layout>
);

export default Gallery;
